export const compareParam = 'compareIds';

export const getCompareIdsFromUrl = () => {
  const url = new URL(window.location.href);
  const param = url.searchParams.get(compareParam);
  if (param != null) {
    return (param || '').split(',');
  }
  return [];
};

export const removeCompareParam = () => {
  const url = new URL(window.location.href);
  url.searchParams.delete(compareParam);
  url.searchParams.delete('utm_source');
  url.searchParams.delete('utm_medium');
  url.searchParams.delete('utm_campaign');
  window.history.replaceState(null, '', url);
};

export const generateCompareUrl = (list: string[]) => {
  const newUrl = new URL(window.location.href?.split('?')?.[0]);
  newUrl.searchParams.append(compareParam, list.join(','));
  newUrl.searchParams.append('utm_source', 'comparison-table-share-link');
  newUrl.searchParams.append('utm_medium', 'referral');
  newUrl.searchParams.append('utm_campaign', 'comparison-table');
  return newUrl?.href;
};

export const updateCompareUrlParam = (list: string[]) => {
  const url = new URL(window.location.href);
  const currentParam = url.searchParams.get(compareParam);
  if (currentParam == null) {
    url.searchParams.append(compareParam, list.join(','));
    window.history.replaceState(null, '', url);
  } else {
    url.searchParams.set(compareParam, list.join(','));
    window.history.replaceState(null, '', url);
  }
};

export const shouldRenderCompareOnInit = () => {
  const compareIds = getCompareIdsFromUrl();
  if (Array.isArray(compareIds) && compareIds?.length > 0) {
    return true;
  }
  return false;
};
